export class CreateStandardConstants {
  static readonly HTTP_STATUS_CODES = {
    OK: 200,
    CREATED: 201,
    NO_CONTENT: 204,
    SPECIAL_CASE: 208
  };
}


// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-standard-head/create-standard.constants.ts